module.exports = __webpack_public_path__ + "static/media/tik-tok.819dd53e.svg";